// extracted by mini-css-extract-plugin
export default {"ruleName":"RulesGrid_ruleName__x4kKf","ruleGrid":"RulesGrid_ruleGrid__Qmn3O"};